import React from 'react';
import { motion } from 'framer-motion';
import styles from './DecorativeHeading.module.css';

const DecorativeHeading = ({ children, gujaratiText, variant = 'green', className = '' }) => {
    const baseClass = styles.decorativeHeading;
    const variantClass = variant === 'gold' ? styles.gold : '';

    return (
        <div className={styles.headingWrapper}>
            <motion.div
                className={`${baseClass} ${variantClass} ${className}`}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
            >
                <div className={styles.headingContent}>
                    {children}
                    {gujaratiText && (
                        <span className={styles.gujaratiText}>{gujaratiText}</span>
                    )}
                </div>
            </motion.div>
        </div>
    );
};

export const SectionHeading = ({ children, gujaratiText, className = '' }) => {
    return (
        <div className={styles.headingWrapper}>
            <motion.div
                className={`${styles.sectionHeading} ${className}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
            >
                <div className={styles.headingContent}>
                    {children}
                    {gujaratiText && (
                        <span className={styles.gujaratiText}>{gujaratiText}</span>
                    )}
                </div>
            </motion.div>
        </div>
    );
};

export default DecorativeHeading;
